module.exports = __webpack_public_path__ + "img/entertainment-hero.344a1628.jpg";